// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-page-base-info-blocks[data-v-e32a39ca]{grid-gap:8px;display:grid;grid-template-columns:repeat(auto-fit,175px);justify-content:center}@media only screen and (min-width:960px){.job-page-base-info-blocks[data-v-e32a39ca]{grid-template-columns:repeat(auto-fit,190px)}}.job-page-base-info-blocks__block[data-v-e32a39ca]{width:175px}@media only screen and (min-width:960px){.job-page-base-info-blocks__block[data-v-e32a39ca]{width:190px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
